<template>
  <OurPage class="users-add" :title="$t('title.categories.add')" :back-route="backRoute" width="md">
    <CategoriesForm ref="categoriesForm" v-model="form" class="categories-form" />

    <template #footer-left>
      <OurButton class="button" :text="$t('button.add')" @click="onClickSaveButton" />

      <OurButton
        class="button"
        :text="$t('button.back')"
        variant="secondary"
        @click="$router.back()"
      />
    </template>
  </OurPage>
</template>

<script>
import { mapActions } from "vuex";
import apolloMixin from "@/mixins/apollo.mixin";
import { createCatalogCategoryMutation } from "./gql/mutations";
import CategoriesForm from "../_components/CategoriesForm";

export default {
  name: "CategoriesAdd",

  components: {
    CategoriesForm,
  },

  mixins: [apolloMixin],

  data() {
    return {
      backRoute: {
        name: "Back",
        title: this.$t("title.categories._"),
      },
      form: {
        name: "",
        isActive: true,
        sort: 0,
        parentId: null,
        forNotice: false,
        linkedProductCategoryIds: [],
      },
    };
  },

  methods: {
    ...mapActions("catalogCategories", ["refreshCatalogCategories"]),

    async onClickSaveButton() {
      if (!this.$refs.categoriesForm.emitForm()) return;

      const { name, isActive, sort, parentId, forNotice, linkedProductCategoryIds } = this.form;

      const { createCatalogCategory } = await this.$post(
        createCatalogCategoryMutation,
        {
          name,
          isActive,
          sort: Number(sort) || 0,
          parentId,
          forNotice,
          productCategoryIds: linkedProductCategoryIds,
        },
        {
          delaySuccessNotify: true,
        }
      );

      if (createCatalogCategory.id) {
        this.refreshCatalogCategories();
        this.$router.back();
      }
    },
  },
};
</script>
